/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AbsoluteCenter,
  Avatar,
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Skeleton,
  SkeletonCircle,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Spacer,
  Switch,
  Tag,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { TbInfoCircle, TbMinus, TbPlus } from 'react-icons/tb'
import { useLocation, useNavigate } from 'react-router-dom'
import { ArrowLeft, ArrowTopRight, Calendar, LocationMarker, LocationMarkerPlus } from '../../components/icons/icons'
import CustomTabs from '../../components/input/CustomTabs'
import CustomTextarea from '../../components/input/CustomTextarea'
import DatePicker from '../../components/input/DatePicker'
import DatePickerSwipe from '../../components/input/DatePickerSwipe'
import useMobile from '../../hooks/useMobile'

import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getEventDetail, getEvents, postEvent, putEventImage } from '../../api/user/events/Events'
import { getCoachList, getVenueDetail, getVenues } from '../../api/user/play/Play'
import CustomTabsMultiple from '../../components/input/CustomTabsMultiple'
import ImageSelect from '../../components/input/ImageSelect'
import InvalidInput from '../../components/input/InvalidInput'
import SelectAsInput from '../../components/input/SelectAsInput'
import CoachPaymentModal from '../../components/modals/CoachPaymentModal'
import PolicyModal from '../../components/modals/PolicyModal'
import { EVENT_TYPES_FILTERED, EVENT_TYPE_LABELS_FILTERED } from '../../types/EventTypes'

function formatDateTime(dateObject: Date | null, time: number) {
  if (!dateObject) {
    return ''
  }

  // Ensure hour is within 0 to 24 range

  // Set the hour of the date object
  //dateObject.setHours(hours);

  // Get year, month, and day components
  const yyyy = dateObject.getFullYear()
  const MM = String(dateObject.getMonth() + 1).padStart(2, '0') // Month is zero-based
  const dd = String(dateObject.getDate()).padStart(2, '0')

  // Get hour and minute components
  const hours = Math.floor(time) // Extract the integer part (hours)
  const minutes = Math.round((time - hours) * 60) // Extract the decimal part and convert to minutes

  const hh = String(hours).padStart(2, '0')
  const mm = String(minutes).padStart(2, '0')

  //var min = String(dateObject.getMinutes()).padStart(2, '0');

  // Return formatted date and time
  return `${yyyy}-${MM}-${dd}T${hh}:${mm}`
}

export const timeArray: any[] = [
  { label: '12:00am', value: 0.0, string: '00:00:00' },
  { label: '12:15am', value: 0.25, string: '00:15:00' },
  { label: '12:30am', value: 0.5, string: '00:30:00' },
  { label: '12:45am', value: 0.75, string: '00:45:00' },
  { label: '1:00am', value: 1.0, string: '01:00:00' },
  { label: '1:15am', value: 1.25, string: '01:15:00' },
  { label: '1:30am', value: 1.5, string: '01:30:00' },
  { label: '1:45am', value: 1.75, string: '01:45:00' },
  { label: '2:00am', value: 2.0, string: '02:00:00' },
  { label: '2:15am', value: 2.25, string: '02:15:00' },
  { label: '2:30am', value: 2.5, string: '02:30:00' },
  { label: '2:45am', value: 2.75, string: '02:45:00' },
  { label: '3:00am', value: 3.0, string: '03:00:00' },
  { label: '3:15am', value: 3.25, string: '03:15:00' },
  { label: '3:30am', value: 3.5, string: '03:30:00' },
  { label: '3:45am', value: 3.75, string: '03:45:00' },
  { label: '4:00am', value: 4.0, string: '04:00:00' },
  { label: '4:15am', value: 4.25, string: '04:15:00' },
  { label: '4:30am', value: 4.5, string: '04:30:00' },
  { label: '4:45am', value: 4.75, string: '04:45:00' },
  { label: '5:00am', value: 5.0, string: '05:00:00' },
  { label: '5:15am', value: 5.25, string: '05:15:00' },
  { label: '5:30am', value: 5.5, string: '05:30:00' },
  { label: '5:45am', value: 5.75, string: '05:45:00' },
  { label: '6:00am', value: 6.0, string: '06:00:00' },
  { label: '6:15am', value: 6.25, string: '06:15:00' },
  { label: '6:30am', value: 6.5, string: '06:30:00' },
  { label: '6:45am', value: 6.75, string: '06:45:00' },
  { label: '7:00am', value: 7.0, string: '07:00:00' },
  { label: '7:15am', value: 7.25, string: '07:15:00' },
  { label: '7:30am', value: 7.5, string: '07:30:00' },
  { label: '7:45am', value: 7.75, string: '07:45:00' },
  { label: '8:00am', value: 8.0, string: '08:00:00' },
  { label: '8:15am', value: 8.25, string: '08:15:00' },
  { label: '8:30am', value: 8.5, string: '08:30:00' },
  { label: '8:45am', value: 8.75, string: '08:45:00' },
  { label: '9:00am', value: 9.0, string: '09:00:00' },
  { label: '9:15am', value: 9.25, string: '09:15:00' },
  { label: '9:30am', value: 9.5, string: '09:30:00' },
  { label: '9:45am', value: 9.75, string: '09:45:00' },
  { label: '10:00am', value: 10.0, string: '10:00:00' },
  { label: '10:15am', value: 10.25, string: '10:15:00' },
  { label: '10:30am', value: 10.5, string: '10:30:00' },
  { label: '10:45am', value: 10.75, string: '10:45:00' },
  { label: '11:00am', value: 11.0, string: '11:00:00' },
  { label: '11:15am', value: 11.25, string: '11:15:00' },
  { label: '11:30am', value: 11.5, string: '11:30:00' },
  { label: '11:45am', value: 11.75, string: '11:45:00' },
  { label: '12:00pm', value: 12.0, string: '12:00:00' },
  { label: '12:15pm', value: 12.25, string: '12:15:00' },
  { label: '12:30pm', value: 12.5, string: '12:30:00' },
  { label: '12:45pm', value: 12.75, string: '12:45:00' },
  { label: '1:00pm', value: 13.0, string: '13:00:00' },
  { label: '1:15pm', value: 13.25, string: '13:15:00' },
  { label: '1:30pm', value: 13.5, string: '13:30:00' },
  { label: '1:45pm', value: 13.75, string: '13:45:00' },
  { label: '2:00pm', value: 14.0, string: '14:00:00' },
  { label: '2:15pm', value: 14.25, string: '14:15:00' },
  { label: '2:30pm', value: 14.5, string: '14:30:00' },
  { label: '2:45pm', value: 14.75, string: '14:45:00' },
  { label: '3:00pm', value: 15.0, string: '15:00:00' },
  { label: '3:15pm', value: 15.25, string: '15:15:00' },
  { label: '3:30pm', value: 15.5, string: '15:30:00' },
  { label: '3:45pm', value: 15.75, string: '15:45:00' },
  { label: '4:00pm', value: 16.0, string: '16:00:00' },
  { label: '4:15pm', value: 16.25, string: '16:15:00' },
  { label: '4:30pm', value: 16.5, string: '16:30:00' },
  { label: '4:45pm', value: 16.75, string: '16:45:00' },
  { label: '5:00pm', value: 17.0, string: '17:00:00' },
  { label: '5:15pm', value: 17.25, string: '17:15:00' },
  { label: '5:30pm', value: 17.5, string: '17:30:00' },
  { label: '5:45pm', value: 17.75, string: '17:45:00' },
  { label: '6:00pm', value: 18.0, string: '18:00:00' },
  { label: '6:15pm', value: 18.25, string: '18:15:00' },
  { label: '6:30pm', value: 18.5, string: '18:30:00' },
  { label: '6:45pm', value: 18.75, string: '18:45:00' },
  { label: '7:00pm', value: 19.0, string: '19:00:00' },
  { label: '7:15pm', value: 19.25, string: '19:15:00' },
  { label: '7:30pm', value: 19.5, string: '19:30:00' },
  { label: '7:45pm', value: 19.75, string: '19:45:00' },
  { label: '8:00pm', value: 20.0, string: '20:00:00' },
  { label: '8:15pm', value: 20.25, string: '20:15:00' },
  { label: '8:30pm', value: 20.5, string: '20:30:00' },
  { label: '8:45pm', value: 20.75, string: '20:45:00' },
  { label: '9:00pm', value: 21.0, string: '21:00:00' },
  { label: '9:15pm', value: 21.25, string: '21:15:00' },
  { label: '9:30pm', value: 21.5, string: '21:30:00' },
  { label: '9:45pm', value: 21.75, string: '21:45:00' },
  { label: '10:00pm', value: 22.0, string: '22:00:00' },
  { label: '10:15pm', value: 22.25, string: '22:15:00' },
  { label: '10:30pm', value: 22.5, string: '22:30:00' },
  { label: '10:45pm', value: 22.75, string: '22:45:00' },
  { label: '11:00pm', value: 23.0, string: '23:00:00' },
  { label: '11:15pm', value: 23.25, string: '23:15:00' },
  { label: '11:30pm', value: 23.5, string: '23:30:00' },
  { label: '11:45pm', value: 23.75, string: '23:45:00' },
]

const lvblWaiver = [
  {
    title: 'Data Collection',
    description: 'We collect data for analytics and usage stats. Read Privacy Policy.',
  },
  {
    title: 'Promotions',
    description: 'Stay in the Loop with LVBL: Enjoy Exclusive Promotions Without Spam or Sharing Your Data!',
  },
]

const LocationListItem = ({
  name,
  address,
  thumbnail,
  onClick,
}: {
  name: string
  address: string
  thumbnail: string
  onClick: () => void
}) => {
  return (
    <Flex
      w="100%"
      alignItems="center"
      justifyContent="space-between"
      cursor="pointer"
      onClick={() => onClick()}
      mb="20px"
    >
      <Flex alignItems="top" gap="4px">
        <Avatar src={thumbnail} w="26px" h="26px" border="1px solid #dce2ea" />
        <Box>
          <Text variant="title" fontSize="md" lineHeight="18px">
            {name}
          </Text>
          <Text variant="subtle" fontSize="sm">
            {address}
          </Text>
        </Box>
      </Flex>
      <Icon viewBox="0 0 16 16">
        <ArrowTopRight color="#292D32" />
      </Icon>
    </Flex>
  )
}

export const CoachTagItem = ({
  name,
  avatar,
  isSelected,
  onClick,
  onOpenModal,
}: {
  name: string
  avatar: string
  isSelected?: boolean
  onClick: () => void

  onOpenModal?: () => void
}) => {
  return (
    <Tag variant={isSelected ? 'heavy' : 'light'} userSelect="none" gap="8px" p="0 6px">
      <Avatar w="22px" h="22px" src={avatar} border="1px solid white" /> {name}
      {onOpenModal && <Icon onClick={() => onOpenModal()} h="20px" w="20px" as={TbInfoCircle} cursor="pointer" />}
      <Icon onClick={onClick} as={isSelected ? TbMinus : TbPlus} cursor="pointer"></Icon>
    </Tag>
  )
}

export const LocationSelectSection = ({
  onSelect,
  showDuplicate = true,
}: {
  onSelect: (v: any) => void
  showDuplicate?: boolean
}) => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')
  const [eventSearch, setEventSearch] = useState('')
  const [debouncedEventSearch, setDebouncedEventSearch] = useState('')

  useEffect(() => {
    const handle = setTimeout(() => setDebouncedSearch(search), 300)
    return () => clearTimeout(handle)
  }, [search])

  useEffect(() => {
    const handle = setTimeout(() => setDebouncedEventSearch(eventSearch), 250)
    return () => clearTimeout(handle)
  }, [eventSearch])

  const isDebouncingEvents = eventSearch.length > 0 && eventSearch !== debouncedEventSearch
  const venues = useQuery(
    ['getVenues', debouncedSearch],
    () =>
      getVenues({
        venue_search: debouncedSearch,
        page_size: 5,
        minimal: true,
      }),
    {
      enabled: debouncedSearch.length > 0,
    }
  )

  const events = useQuery(
    ['getEvents', debouncedEventSearch],
    () =>
      getEvents({
        page: 1,
        page_size: 5,
        search: debouncedEventSearch,
        venues: [],
      }),
    {
      enabled: debouncedEventSearch.length > 0,
    }
  )

  const [isLoading, setIsLoading] = useState(false)

  if (isLoading)
    return (
      <>
        <Skeleton borderRadius="10px" w="100%" h="100px" />
      </>
    )

  return (
    <>
      <Text variant="subtle" mb="5px">
        Enter event location to continue creating your event
      </Text>

      <InputGroup>
        <InputLeftElement>
          <Icon width="20px" height="20px" viewBox="0 0 24 24">
            <LocationMarker color="#171C22" />
          </Icon>
        </InputLeftElement>
        <Input
          variant="filled"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search for a location"
        />
      </InputGroup>
      <Box
        p="20px"
        border="1px solid #DCE2EA"
        borderRadius="10px"
        mt="10px"
        boxShadow="0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14"
      >
        {venues.isLoading &&
          [1, 1, 1, 1, 1].map((_, i) => (
            <Flex key={`skeleton-${i}`} w="100%" alignItems="center" justifyContent="space-between" mb="20px">
              <Flex alignItems="top" gap="4px">
                <SkeletonCircle size="26px" />
                <Box w="300px">
                  <Skeleton h="16px" w="30%" mb="4px" />
                  <Skeleton h="12px" w="73%" mb="4px" />
                </Box>
              </Flex>
              <SkeletonCircle size="20px" />
            </Flex>
          ))}
        {venues.data?.venues?.map((venue: any, i: number) => {
          return (
            <>
              <LocationListItem
                key={i}
                name={venue.name}
                address={venue.address}
                thumbnail={venue.image ?? ''}
                onClick={() => {
                  onSelect(venue.id)
                  setIsLoading(true)
                }}
              />
            </>
          )
        })}
        <Flex
          cursor="pointer"
          w="100%"
          gap="4px"
          alignItems="center"
          onClick={() => {
            if (window.location.href.includes('admin')) {
              navigate(`/admin/venues/create`)
            } else {
              navigate('/host/location/create')
            }
          }}
        >
          <Icon w="20px" h="20px" viewBox="0 0 20 20" fill="none" color="#171C22">
            <LocationMarkerPlus />
          </Icon>
          <Text userSelect="none" variant="title" fontSize="md">
            Create a new location
          </Text>
        </Flex>
      </Box>
      {showDuplicate && (
        <>
          <Box position="relative" mt="60px">
            <Divider />
            <AbsoluteCenter bg="#ffffff" px="4">
              OR
            </AbsoluteCenter>
          </Box>
          <Text variant="subtle" mb="5px" mt="60px">
            Duplicate a previous event
          </Text>
          <InputGroup>
            <InputLeftElement>
              <Icon width="20px" height="20px" viewBox="0 0 24 24">
                <Calendar />
              </Icon>
            </InputLeftElement>
            <Input
              variant="filled"
              value={eventSearch}
              onChange={(e) => setEventSearch(e.target.value)}
              placeholder="Search for an event by name"
            />
          </InputGroup>
          {eventSearch.length > 0 && (
            <Box
              p="20px"
              border="1px solid #DCE2EA"
              borderRadius="10px"
              mt="10px"
              boxShadow="0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14"
            >
              {(events.isLoading || isDebouncingEvents) &&
                [1, 1, 1, 1, 1].map((_, i) => (
                  <Flex key={`skeleton-${i}`} w="100%" alignItems="center" justifyContent="space-between" mb="20px">
                    <Flex alignItems="top" gap="4px">
                      <SkeletonCircle size="26px" />
                      <Box w="300px">
                        <Skeleton h="16px" w="30%" mb="4px" />
                        <Skeleton h="12px" w="73%" mb="4px" />
                      </Box>
                    </Flex>
                    <SkeletonCircle size="20px" />
                  </Flex>
                ))}
              {events.data?.events?.map((event: any, i: number) => {
                return (
                  <>
                    <LocationListItem
                      key={i}
                      name={event.title}
                      address={event.venue.address}
                      thumbnail={event.venue.images.length > 0 ? event.venue.images[0] : ''}
                      onClick={() => {
                        // Warm cache for instant autofill on next step
                        queryClient.prefetchQuery(['getEventDetail', event.id], () => getEventDetail(event.id))
                        onSelect({ venueId: event.venue.id, duplicateEventId: event.id })
                        setIsLoading(true)
                      }}
                    />
                  </>
                )
              })}
              {!events.isLoading && !isDebouncingEvents && (events.data?.events?.length ?? 0) === 0 && (
                <Text variant="subtle">No event found</Text>
              )}
            </Box>
          )}
        </>
      )}
    </>
  )
}

const EventCreationSection = ({ isMobile }: { isMobile?: boolean }) => {
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)

  const navigate = useNavigate()
  const [date, setDate] = useState<Date | null>(tomorrow)
  const [data, setData] = useState({
    title: '',
    type: -1,
    secondary_type: -1,
    startTime: null as string | null,
    endTime: null as string | null,
    court: '',
    courtType: -1,
    level: [] as number[],
    coaches: [] as { avatar: string; name: string; id: string }[],
    about: '',
    slots: 9,
    locationCost: '',
    eventCost: '',
    fee: '',
    privateCode: '',
    image: null as File | null,
    isRecurring: false,
    recurrenceType: -1, // 0: weekly, 1: bi_weekly, 2: monthly
    recurrenceEndDate: null as Date | null,
  })

  const [errors, setErrors] = useState({
    title: false,
    type: false,
    secondary_type: false,
    time: false,
    court: false,
    courtType: false,
    level: false,
    slots: false,
    locationCost: false,
    eventCost: false,
    privateCode: false,
    fee: false,
    recurrenceType: false,
    recurrenceEndDate: false,
  })

  const { isOpen: isPolicyOpen, onOpen: onPolicyOpen, onClose: onPolicyClose } = useDisclosure()
  const location = useLocation()

  const [id, setId] = useState('0')
  const [duplicateId, setDuplicateId] = useState<string | null>(null)

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    setId(queryParams.get('id') ?? '0')
    setDuplicateId(queryParams.get('duplicate'))
  }, [location.search])

  const [timeError, setTimeError] = useState(0)

  const [isPrivate, setIsPrivate] = useState(false)

  const venue = useQuery(['getVenue', id], () => getVenueDetail({ id }))

  // Prefill when duplicating an event
  const eventToDuplicate = useQuery(['getEventDetail', duplicateId], () => getEventDetail(duplicateId ?? ''), {
    enabled: !!duplicateId,
  })

  // State for holding the duplicated image URL
  const [duplicatedImageUrl, setDuplicatedImageUrl] = useState<string | null>(null)

  useEffect(() => {
    if (!eventToDuplicate.data) return
    const ev = (eventToDuplicate.data as any).event ?? eventToDuplicate.data

    // Title
    const newTitle = ev.title ?? ''

    // Type mapping
    const typeIndex = EVENT_TYPES_FILTERED.findIndex((t: string) => t === ev.type)

    const secondaryTypeIndex = EVENT_TYPES_FILTERED.findIndex((t: string) => t === ev.secondary_type)

    // Date and time
    const start = ev.start_time ? new Date(ev.start_time) : null
    const startHours = start ? start.getHours() : 0
    const startMinutes = start ? start.getMinutes() : 0
    const startFrac = (startHours || 0) + (startMinutes || 0) / 60
    const durationMinutes = ev.duration ?? 60
    const endFrac = startFrac + durationMinutes / 60

    // Court and surface
    const court = ev.court ?? ''
    const surface = ev.surface ?? -1

    // Levels
    const levels = Array.isArray(ev.skill_level) ? ev.skill_level : []

    // Costs and fee
    const maxPlayers = ev.max_players ?? 9
    const venueFixed = ev.venue_fixed_rate ?? ''
    const venueHourly = ev.venue_hourly_rate ?? ''
    const fee = ev.fee ?? ''

    // Description
    const description = ev.description ?? ''

    // Private code
    const privateCode = ev.private_code ?? ''

    // Image URL from duplicated event
    const imageUrl = ev.image ?? null

    // Coaches
    const coachesBasic = Array.isArray(ev.coaches)
      ? ev.coaches.map((c: any) => ({ id: c.id, name: c.display_name, avatar: c.profile_image }))
      : []
    const coachesRates = Array.isArray(ev.coaches)
      ? ev.coaches.map((c: any) => ({ id: c.id, hourly_rate: c.hourly_rate ?? 0, fixed_rate: c.fixed_rate ?? 0 }))
      : []

    // Recurring data
    const isRecurring = !!ev.is_recurring
    const recurrenceTypeIndex = ev.recurrence_type ? ['weekly', 'bi_weekly', 'monthly'].indexOf(ev.recurrence_type) : -1
    const recurrenceEndDate = ev.recurrence_end_date ? new Date(ev.recurrence_end_date) : null

    setIsPrivate(!!ev.private_code)
    setDuplicatedImageUrl(imageUrl)
    setData((prev) => ({
      ...prev,
      title: newTitle,
      type: typeIndex,
      secondary_type: secondaryTypeIndex,
      startTime: start ? startFrac.toString() : prev.startTime,
      endTime: endFrac.toString(),
      court,
      courtType: surface,
      level: levels,
      about: description,
      slots: maxPlayers,
      locationCost: venueFixed?.toString?.() ?? venueFixed,
      eventCost: venueHourly?.toString?.() ?? venueHourly,
      fee: fee?.toString?.() ?? fee,
      privateCode,
      coaches: coachesBasic,
      image: prev.image, // Preserve user's image selection if they already chose one
      isRecurring,
      recurrenceType: recurrenceTypeIndex,
      recurrenceEndDate,
    }))
    setCoachRoaster(coachesRates)
  }, [eventToDuplicate.data])

  const validateFormData = () => {
    console.log(data)

    const errors: any = {
      title: data.title === '',
      type: data.type === -1,
      secondary_type: false, // Secondary type is now optional
      time:
        !data.startTime ||
        !data.endTime ||
        (parseFloat(data?.startTime ?? '0') ?? 0) > (parseFloat(data?.endTime ?? '0') ?? 0) ||
        new Date(formatDateTime(date, parseFloat(data?.startTime ?? '0'))) < new Date(),
      court: data.court === '',
      courtType: data.courtType === -1,
      level: data.level.length === 0,
      slots: data.slots < 0,
      locationCost: data.locationCost === '' || parseFloat(data.locationCost) < 0,
      eventCost: data.eventCost === '' || parseFloat(data.eventCost) < 0,
      fee: data.fee === '' || parseFloat(data.fee) < 0,
      privateCode: data.privateCode === '' && isPrivate,
      recurrenceType: data.isRecurring && data.recurrenceType === -1,
      recurrenceEndDate: data.isRecurring && (!data.recurrenceEndDate || data.recurrenceEndDate <= new Date()),
    }
    if (!data.startTime || !data.endTime) {
      setTimeError(2) // New error type for missing times
    } else if (new Date(formatDateTime(date, parseFloat(data?.startTime ?? '0'))) < new Date()) {
      setTimeError(1)
    } else {
      setTimeError(0)
    }

    setErrors(errors)
    const hasErrors = Object.values(errors).some((v) => v)
    return !hasErrors
  }

  const queryClient = useQueryClient()

  const addEventImage = useMutation(['putEventImage'], putEventImage, {
    onSuccess: (_, variables: any) => {
      queryClient.invalidateQueries('getEvents')

      // Wait 1 second for image processing, then navigate
      setTimeout(() => {
        if (location.pathname.includes('admin')) {
          navigate(`/admin/events`)
        } else {
          navigate(`/host/event/create/success?id=${variables.id}`)
        }
      }, 1000)
    },
    onError: (error: any, variables: any) => {
      console.error('Failed to upload event image:', error)
      // Still navigate to success page even if image upload fails
      // The event was created successfully, just without the image
      if (location.pathname.includes('admin')) {
        navigate(`/admin/events`)
      } else {
        navigate(`/host/event/create/success?id=${variables.id}`)
      }
    },
  })

  // Function to download image from URL as blob
  const downloadImageAsBlob = async (imageUrl: string): Promise<File | null> => {
    try {
      const response = await fetch(imageUrl)
      const blob = await response.blob()
      const fileName = `dup-img-${Date.now()}.jpg`
      return new File([blob], fileName, { type: blob.type || 'image/jpeg' })
    } catch (error) {
      console.error('Failed to download image:', error)
      return null
    }
  }

  const addEvent = useMutation(['postEvent'], postEvent, {
    onSuccess: async (res: any) => {
      queryClient.invalidateQueries('getEvents')

      // Check if we need to upload an image
      const needsImageUpload = data.image || (duplicatedImageUrl && !data.image)

      if (needsImageUpload) {
        let imageToUpload = data.image

        // If no new image selected but we have a duplicated image URL, download it
        if (!data.image && duplicatedImageUrl) {
          imageToUpload = await downloadImageAsBlob(duplicatedImageUrl)
        }

        if (imageToUpload) {
          addEventImage.mutate({
            id: res.event_id,
            data: { image: imageToUpload },
          })
        } else {
          // Failed to download duplicated image, navigate immediately
          if (location.pathname.includes('admin')) {
            navigate(`/admin/events`)
          } else {
            navigate(`/host/event/create/success?id=${res.event_id}`)
          }
        }
      } else {
        // No image to upload, navigate immediately
        if (location.pathname.includes('admin')) {
          navigate(`/admin/events`)
        } else {
          navigate(`/host/event/create/success?id=${res.event_id}`)
        }
      }
    },
  })

  const [coach, setCoach] = useState('')
  const coaches = useQuery(['getCoachList', coach], () => getCoachList({ search: coach }))
  const coachSelected = data.coaches
  const setCoachSelected = (c: any[]) => setData({ ...data, coaches: c })
  const coachOptions =
    coaches.data?.profiles
      ?.filter((c: any) => coachSelected.every((d: any) => d.id != c.id))
      .map((c: any) => ({
        name: c.display_name,
        id: c.id,
        avatar: c.profile_image,
      })) || []

  const [coachRoaster, setCoachRoaster] = useState<any[]>([])
  const [selectedCoachId, setSelectedCoachId] = useState('')

  useEffect(() => {
    setCoachRoaster(
      coachSelected.map((c: any) => {
        if (coachRoaster.some((d: any) => d.id == c.id)) {
          return coachRoaster.find((d: any) => d.id == c.id)
        }

        return { id: c.id, hourly_rate: 0, fixed_rate: 0 }
      })
    )
  }, [coachSelected])

  const { isOpen: isOpenCoachModal, onOpen: onOpenCoachModal, onClose: onCloseCoachModal } = useDisclosure()

  const validateCurrencyInput = (value: string) => {
    const regex = /^\d{0,4}(\.\d{1,2})?$/
    return regex.test(value)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    const { value } = e.target
    if (validateCurrencyInput(value)) {
      setData((prevData) => ({ ...prevData, [field]: value }))
    }
  }

  return (
    <>
      {/* <UserSelectModal 
            isOpen={isOpen}
            onClose={onClose}
            users={[
                { id: '1', name: 'John Doe', avatar: '/temp/avatar1.png', isSelected: true },
                { id: '2', name: 'John Doe', avatar: '/temp/avatar1.png', isSelected: false },
                { id: '3', name: 'John Doe', avatar: '/temp/avatar1.png', isSelected: false },
                { id: '4', name: 'John Doe', avatar: '/temp/avatar1.png', isSelected: false },
            ]}
            onChange={() => {}}
            isMobile={isMobile}
        /> */}

      <CoachPaymentModal
        isOpen={isOpenCoachModal}
        onClose={onCloseCoachModal}
        id={selectedCoachId}
        coach={coachRoaster.find((c) => c.id == selectedCoachId)}
        onSave={(fixed_rate: number, hourly_rate: number) => {
          setCoachRoaster((prev) =>
            prev.map((c) => {
              if (c.id == selectedCoachId) {
                return { id: c.id, fixed_rate, hourly_rate }
              }
              return c
            })
          )
        }}
      />

      <PolicyModal header="LVBL Fee Structure" content={lvblWaiver} isOpen={isPolicyOpen} onClose={onPolicyClose} />
      <Skeleton isLoaded={!venue.isLoading} borderRadius="10px">
        <Flex
          w="100%"
          p="20px"
          borderRadius="10px"
          bg="white"
          border="1px solid #DCE2EA"
          boxShadow="0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14"
          justifyContent="space-between"
          alignItems="center"
          gap="20px"
        >
          <Flex alignItems="center" gap="20px">
            <Box
              w="68px"
              h="68px"
              borderRadius="4px"
              bgImage={venue.data?.images.length > 0 ? venue.data?.images[0] : ''}
              bgPos="center"
              bgSize="cover"
            />
            <Box maxW="55%">
              <Text variant="title" fontSize={isMobile ? 'lg' : '2xl'} lineHeight={isMobile ? '15px' : '21px'}>
                {venue.data?.name}
              </Text>
              <Spacer h="10px" />
              <Text variant="subtle" fontSize="sm" lineHeight="16px">
                {venue.data?.address}
              </Text>
            </Box>
          </Flex>
          <Button
            onClick={() => {
              let baseRoute = '/create' // Default base route
              if (window.location.href.includes('admin')) {
                baseRoute = '/admin/events/create'
              } else if (location.pathname.includes('host')) {
                baseRoute = '/host/event/create'
              }

              navigate(`${baseRoute}${location.search.replace(/step=\d+/, 'step=0')}`, {
                replace: true, // Replace the current entry in the history stack
              })
            }}
            variant="link"
          >
            Change
          </Button>
        </Flex>
      </Skeleton>

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Event Title <span style={{ color: '#DC3B31' }}>*</span>
      </Text>
      <Input
        placeholder="My Event"
        maxLength={100}
        value={data.title}
        onChange={(e) => setData((prevData) => ({ ...prevData, title: e.target.value }))}
      />
      <InvalidInput isError={errors.title} label="title" />

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Event Type <span style={{ color: '#DC3B31' }}>*</span>
      </Text>
      <Box maxW="400px">
        <CustomTabs
          name="parking"
          value={data.type}
          onChange={(v: number) => setData((prevData) => ({ ...prevData, type: v }))}
          choices={EVENT_TYPE_LABELS_FILTERED}
        />
      </Box>
      <InvalidInput isError={errors.type} label="type" />

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Secondary Type
      </Text>
      <Text variant="subtle" fontSize="sm" mb="10px">
        Optional - used for filtering events by multiple categories
      </Text>
      <Box maxW="400px">
        <CustomTabs
          name="secondary_type"
          value={data.secondary_type}
          onChange={(v: number) => setData((prevData) => ({ ...prevData, secondary_type: v }))}
          choices={EVENT_TYPE_LABELS_FILTERED}
        />
      </Box>
      <InvalidInput isError={errors.secondary_type} label="secondary type" />

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Select Date <span style={{ color: '#DC3B31' }}>*</span>
      </Text>
      {isMobile ? (
        <DatePickerSwipe date={date} setDate={setDate} />
      ) : (
        <DatePicker daysPerPage={7} date={date} setDate={setDate} />
      )}

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Select Time <span style={{ color: '#DC3B31' }}>*</span>
      </Text>
      <Flex alignItems="center">
        <Select
          size="sm"
          w="128px"
          placeholder="Starting hour"
          value={data?.startTime ?? undefined}
          onChange={(e: any) => {
            const newStartTime = parseFloat(e.target.value)

            // If the new start time is >= current end time, set end time to one hour after start time
            if (data.endTime && newStartTime >= parseFloat(data.endTime ?? '0')) {
              const closing = timeArray.find((time) => time.string == venue.data?.closing_time)?.value ?? 24
              const newEndTime = Math.min(newStartTime + 1.0, closing)
              setData((prevData) => ({ ...prevData, startTime: e.target.value, endTime: newEndTime.toString() }))
            } else {
              setData((prevData) => ({ ...prevData, startTime: e.target.value }))
            }
          }}
        >
          {timeArray
            .filter((time: { label: string; value: number; string: string }) => {
              const opening = timeArray.find((time) => time.string == venue.data?.opening_time)?.value ?? 0
              const closing = timeArray.find((time) => time.string == venue.data?.closing_time)?.value ?? 24
              return time.value >= opening && time.value < closing
            })
            .map((time: { label: string; value: number }, i: number) => {
              return (
                <option key={i} value={time.value}>
                  {time.label}
                </option>
              )
            })}
        </Select>
        <Text pl="10px" pr="10px" variant="title" fontSize="sm">
          to
        </Text>
        <Select
          size="sm"
          w="128px"
          placeholder="Finishing hour"
          value={data?.endTime ?? undefined}
          onChange={(e: any) => setData((prevData) => ({ ...prevData, endTime: e.target.value }))}
        >
          {timeArray
            .filter((time: { label: string; value: number; string: string }) => {
              const opening = timeArray.find((time) => time.string == venue.data?.opening_time)?.value ?? 0
              const closing = timeArray.find((time) => time.string == venue.data?.closing_time)?.value ?? 0
              const start = parseFloat(data.startTime ?? '0')
              return time.value <= closing && time.value > start && time.value > opening
            })
            .map((time: { label: string; value: number }, i: number) => {
              return (
                <option key={i} value={time.value}>
                  {time.label}
                </option>
              )
            })}
        </Select>
      </Flex>
      <InvalidInput
        isError={errors.time}
        override={
          timeError == 2
            ? 'Please select both start and end times'
            : timeError == 1
            ? "Event can't begin in the past"
            : 'Starting Time cannot be after the End Time'
        }
      />

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Court <span style={{ color: '#DC3B31' }}>*</span>
      </Text>
      <Input
        placeholder="A12(Outdoor)"
        maxLength={50}
        value={data.court}
        onChange={(e) => setData((prevData) => ({ ...prevData, court: e.target.value }))}
      />
      <InvalidInput isError={errors.court} label="court" />

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Type of Court <span style={{ color: '#DC3B31' }}>*</span>
      </Text>
      <Box maxW="400px">
        <CustomTabs
          name="parking"
          value={data.courtType}
          onChange={(v: number) => setData((prevData) => ({ ...prevData, courtType: v }))}
          choices={['Hard', 'Clay', 'Indoor', 'Sand', 'Grass', 'Other']}
        />
      </Box>
      <InvalidInput isError={errors.courtType} label="court type" />

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Level <span style={{ color: '#DC3B31' }}>*</span>
      </Text>
      <Box maxW="400px">
        <CustomTabsMultiple
          value={data.level.join(',')}
          onChange={(v: string) => {
            const selectedLevels = v
              .split(',')
              .filter((item) => item !== '')
              .map((item) => parseInt(item))
            setData((prevData) => ({ ...prevData, level: selectedLevels }))
          }}
          choices={['Beginner', 'Intermediate', 'Intermediate High', 'Advanced', 'Advanced 4.5+', 'Mixed-Level']}
          results={['0', '1', '2', '3', '4', '5']}
        />
      </Box>
      <InvalidInput isError={errors.level} label="skill level" />

      <Text variant="title" fontSize="md" mt="10px" mb="5px">
        Coaches
      </Text>
      <SelectAsInput
        value={null}
        onChange={(value: any) => {
          if (value) {
            setCoachSelected([...coachSelected, value])
            setSelectedCoachId(value.id)
            onOpenCoachModal()
          }
        }}
        search={coach}
        onSearchChange={(coach) => setCoach(coach)}
        options={coachOptions}
        isLoading={coaches.isLoading}
        placeholder="Search coaches..."
        h="40px"
        w="100%"
      />
      <Flex gap="12px" flexWrap="wrap">
        {/* <CoachTagItem 
                    name='John Doe' avatar='/temp/avatar1.png'
                    onClick={() => {}}
                /> */}
        {coachSelected.map((c: any, i: number) => {
          return (
            <CoachTagItem
              key={i}
              name={c.name}
              avatar={c.avatar}
              onClick={() => {
                setCoachSelected(coachSelected.filter((d: any) => d.id != c.id))
              }}
              isSelected
              onOpenModal={() => {
                //console.log("AA")
                setSelectedCoachId(c.id)
                onOpenCoachModal()
              }}
            />
          )
        })}
      </Flex>

      {/* <Text variant='title' fontSize={isMobile ? 'md' : 'lg'} lineHeight='19px' mt='25px' mb='10px'>
            Select Coach <span style={{color:'#DC3B31'}}>*</span>
        </Text>

        <Flex gap='12px' flexWrap='wrap'>
            {/* <CoachTagItem 
                name='John Doe' avatar='/temp/avatar1.png'
                onClick={() => {}}
            /> }
            <CoachTagItem 
                name='John Doe' avatar='/temp/avatar1.png'
                onClick={() => {}}
                isSelected
            />
            <Tag variant='light'
                cursor='pointer' userSelect='none'
                onClick={() => onOpen()}
            >View all coaches</Tag>
        </Flex> */}

      <Flex gap="4px" mt="12px">
        <Center>
          <Switch size="md" value={isPrivate ? 1 : 0} onChange={() => setIsPrivate(!isPrivate)} />
        </Center>
        <Text>Add an invite code to your event</Text>
      </Flex>

      {isPrivate && (
        <>
          <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
            Invite Code <span style={{ color: '#DC3B31' }}>*</span>
          </Text>
          <Input
            placeholder="ABC123"
            maxLength={50}
            value={data.privateCode}
            onChange={(e) =>
              setData((prevData) => ({
                ...prevData,
                privateCode: e.target.value,
              }))
            }
          />
          <InvalidInput isError={errors.privateCode} label="invite code" />
        </>
      )}

      <Flex gap="4px" mt="25px" alignItems="center">
        <Center>
          <Switch
            size="md"
            isChecked={data.isRecurring}
            onChange={() =>
              setData((prevData) => ({
                ...prevData,
                isRecurring: !prevData.isRecurring,
                recurrenceType: !prevData.isRecurring ? prevData.recurrenceType : -1,
                recurrenceEndDate: !prevData.isRecurring ? prevData.recurrenceEndDate : null,
              }))
            }
          />
        </Center>
        <Text>Make this event recurring</Text>
      </Flex>

      {data.isRecurring && (
        <>
          <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
            Recurrence Type <span style={{ color: '#DC3B31' }}>*</span>
          </Text>
          <Box maxW="400px">
            <CustomTabs
              name="recurrence"
              value={data.recurrenceType}
              onChange={(v: number) => setData((prevData) => ({ ...prevData, recurrenceType: v }))}
              choices={['Weekly', 'Bi-Weekly', 'Monthly']}
            />
          </Box>
          <InvalidInput isError={errors.recurrenceType} label="recurrence type" />

          <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
            Recurring End Date <span style={{ color: '#DC3B31' }}>*</span>
          </Text>
          {isMobile ? (
            <DatePickerSwipe
              date={data.recurrenceEndDate}
              setDate={(date) => {
                const nextDate = typeof date === 'function' ? date(data.recurrenceEndDate) : date
                setData((prevData) => ({ ...prevData, recurrenceEndDate: nextDate }))
              }}
            />
          ) : (
            <DatePicker
              daysPerPage={7}
              date={data.recurrenceEndDate}
              setDate={(date) => {
                const nextDate = typeof date === 'function' ? date(data.recurrenceEndDate) : date
                setData((prevData) => ({ ...prevData, recurrenceEndDate: nextDate }))
              }}
            />
          )}
          <InvalidInput isError={errors.recurrenceEndDate} label="recurrence end date" />
        </>
      )}

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        About Event
      </Text>
      <CustomTextarea
        value={data.about}
        onChange={(v) => setData((prevData) => ({ ...prevData, about: v }))}
        placeholder="Some details about the event..."
      />

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Event Image
      </Text>
      {/* Show duplicated image preview if available and no new image selected */}
      {duplicatedImageUrl && !data.image ? (
        <Box mb="10px">
          <Box
            w="100%"
            maxW="400px"
            h="200px"
            borderRadius="10px"
            overflow="hidden"
            border="1px solid #DCE2EA"
            cursor="pointer"
            onClick={() => {
              // Clear the duplicated image so user can select a new one
              setDuplicatedImageUrl(null)
            }}
          >
            <img
              src={duplicatedImageUrl}
              alt="Event"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          </Box>
          <Text variant="subtle" fontSize="xs" mt="5px">
            Click image to remove and upload a new one
          </Text>
        </Box>
      ) : (
        <ImageSelect
          image={data.image}
          onChange={(image) => setData((prevData) => ({ ...prevData, image }))}
          isImage
          displayFullImage
        />
      )}

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Available Slots <span style={{ color: '#DC3B31' }}>*</span>
      </Text>
      <Text variant="subtle" mb="5px">
        Select the maximum available slots <span style={{ color: '#171C22' }}>120 slots</span>
      </Text>
      <Flex justifyContent="space-between">
        <Slider
          zIndex="0"
          value={data.slots}
          onChange={(v) => setData((prevData) => ({ ...prevData, slots: v }))}
          w="80%"
          max={120}
          min={0}
        >
          <SliderTrack>
            <SliderFilledTrack />
          </SliderTrack>
          <SliderThumb />
        </Slider>
        <Text variant="title" fontSize="md">
          {data.slots} slots
        </Text>
      </Flex>
      <InvalidInput isError={errors.slots} label="number of slots" />

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Event Cost
      </Text>
      <InputGroup w="130px">
        <InputLeftElement>$</InputLeftElement>
        <Input type="number" placeholder="40.00" value={data.fee} onChange={(e) => handleInputChange(e, 'fee')} />
      </InputGroup>
      <InvalidInput isError={errors.fee} label="event cost" />

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Fixed Location Rate
      </Text>
      <InputGroup w="130px">
        <InputLeftElement>$</InputLeftElement>
        <Input
          type="number"
          placeholder="200.00"
          value={data.locationCost}
          onChange={(e) => handleInputChange(e, 'locationCost')}
        />
      </InputGroup>
      <InvalidInput isError={errors.locationCost} label="rate" />

      <Text variant="title" fontSize={isMobile ? 'md' : 'lg'} lineHeight="19px" mt="25px" mb="10px">
        Hourly Location Rate
      </Text>
      <InputGroup w="130px">
        <InputLeftElement>$</InputLeftElement>
        <Input
          type="number"
          placeholder="200.00"
          value={data.eventCost}
          onChange={(e) => handleInputChange(e, 'eventCost')}
        />
      </InputGroup>
      <InvalidInput isError={errors.eventCost} label="rate" />

      <Button size="sm" variant="link" mt="10px" onClick={onPolicyOpen}>
        LVBL fee structure
      </Button>

      <Button
        variant="heavy"
        w="100%"
        mt="20px"
        onClick={() => {
          if (validateFormData()) {
            const recurringData = data.isRecurring
              ? {
                  is_recurring: true,
                  recurrence_type: ['weekly', 'bi_weekly', 'monthly'][data.recurrenceType],
                  recurrence_end_date: data.recurrenceEndDate
                    ? `${data.recurrenceEndDate.getFullYear()}-${String(data.recurrenceEndDate.getMonth() + 1).padStart(2, '0')}-${String(data.recurrenceEndDate.getDate()).padStart(2, '0')}`
                    : undefined,
                }
              : {
                  is_recurring: false,
                }

            addEvent.mutate({
              title: data.title,
              max_players: data.slots,
              venue_fixed_rate: data.locationCost,
              venue_hourly_rate: data.eventCost,
              start_time: formatDateTime(date, parseFloat(data.startTime ?? '0')),
              duration: parseFloat(data.endTime ?? '24') * 60 - parseFloat(data.startTime ?? '0') * 60,
              description: data.about,
              coaches: coachRoaster, //data.coaches.map(c => c.id),
              venue: id,
              court: data.court,
              skill_level: data.level,
              type: EVENT_TYPES_FILTERED[data.type],
              secondary_type: data.secondary_type !== -1 ? EVENT_TYPES_FILTERED[data.secondary_type] : undefined,
              surface: data.courtType,
              private_code: isPrivate ? data.privateCode : null,
              fee: data.fee,
              ...recurringData,
            })
          }
        }}
        isLoading={addEvent.isLoading || addEventImage.isLoading}
      >
        Create Event
      </Button>
    </>
  )
}

const HostCreateEventPage = () => {
  const isMobile = useMobile(600)
  const navigate = useNavigate()
  const location = useLocation()

  const [step, setStep] = useState('0')

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    setStep(queryParams.get('step') ?? '0')
  }, [location])

  const onLocationSelect = (selection: any) => {
    if (typeof selection === 'string') {
      navigate(`?step=1&id=${selection}`)
      return
    }
    const params = new URLSearchParams()
    params.set('step', '1')
    params.set('id', selection.venueId)
    if (selection.duplicateEventId) params.set('duplicate', selection.duplicateEventId)
    navigate(`?${params.toString()}`)
  }

  return (
    <Box p={isMobile ? '20px' : '30px'}>
      {isMobile ? (
        <></>
      ) : (
        <Flex alignItems="center" gap="15px" mb="20px">
          <IconButton
            minW="34px"
            h="34px"
            variant="light"
            aria-label="new chat"
            onClick={() => navigate(-1)}
            icon={
              <Icon width="20px" height="19px" viewBox="0 0 23 20">
                <ArrowLeft color="#171C22" />
              </Icon>
            }
          />

          <Text variant="header" fontSize="20">
            Create event
          </Text>
        </Flex>
      )}
      <Center mt="20px">
        <Box w={isMobile ? '100%' : '500px'}>
          {step === '0' ? (
            <LocationSelectSection onSelect={onLocationSelect} />
          ) : (
            <EventCreationSection isMobile={isMobile} />
          )}
        </Box>
      </Center>
    </Box>
  )
}

export default HostCreateEventPage
